import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 10.0005C14.75 10.2563 14.6432 10.5123 14.4296 10.7073L7.86707 16.707C7.43982 17.0977 6.74768 17.0977 6.32043 16.707C5.89319 16.3164 5.89319 15.6837 6.32043 15.293L12.1113 10.0005L6.32129 4.70695C5.89404 4.31635 5.89404 3.68356 6.32129 3.29296C6.74853 2.90235 7.44067 2.90235 7.86792 3.29296L14.4304 9.29269C14.644 9.48799 14.75 9.74423 14.75 10.0005Z",
		fill: "#0D2976"
	})
});
export default SvgChevronRight;
